import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Container,
  Input,
  Box,
  InputAdornment,
  IconButton,
  CircularProgress,
  Backdrop,
  MenuItem,
  Select
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import CreateIcon from '@material-ui/icons/Create';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import moment from 'moment';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import { useDocumentsContext } from '../../context/document_context';
import {
  baseUrl,
  gender,
  maritalState,
  titles,
  memberStatuses,
  memberTypes,
  relationShips,
  suffixes,
  benefitTypes
} from '../../utils/constants';
import DependantSub from './DependantSub';
import DependantsQuick from './DependantsQuick';
import DependantsDocs2 from '../dependants/DependantsDocs2';
import DependantsGlo from './DependentsGlo';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function DependantsAdd() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const { towns, suburbs, banks, bankBranches } = useConstantsContext();
  const {
    clientRefId,
    currDependant,
    setClientRefId,
    setDependant,
    currentClient,
    setCurrentClient,
    clearDependant,
    getDependantsList
  } = useClientContext();
  const { setNomDocs } = useDocumentsContext();
  const [memberSearchName, setSearchName] = useState('');
  const [memberCode, setMemberCode] = useState('');
  const [operation, setOperation] = useState('save');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(currDependant);
  const [isDisabled, setDisabled] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupDiag, setOpenPopupDiag] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const PersonalDetailsSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, 'First Name is too Short!')
      .max(50, 'First Name is too Long!')
      .required('First name required'),
    surname: Yup.string()
      .min(2, 'Surname is too Short!')
      .max(50, 'Surname is too Long!')
      .required('Last name required'),
    idNumber: Yup.string().required('ID Number or Birth Cert is requied or other'),
    title_id: Yup.string().required('Title of Member required'),
    // dateOfBirth: Yup.date().required('Date Of Birth required'),
    suffix: Yup.string().required('Suffix is required'),
    // maritalStatus: Yup.string().required('Marital Status is required'),
    memberType_ID: Yup.string().required('Member Type is required'),
    relationship_ID: Yup.string().required('Relation to main member is required')
  });

  //   const initialValue = {
  //     firstName: currDependant.firstName,
  //     surname: currDependant.surname,
  //     idNumber: currDependant.idNumber,
  //     dateOfBirth: moment(currDependant.dateOfBirth).format('yyyy-MM-DD'),
  //     membershipStartDate: moment(currDependant.membershipStartDate).format('yyyy-MM-DD'),

  //     gender: currDependant.gender,
  //     addressLine1: currDependant.addressLine1,
  //     addressLine2: currDependant.addressLine2,
  //     addressLine3: currDependant.addressLine3,
  //     provinceLookupKey: currDependant.provinceLookupKey,
  //     cellNumber: currDependant.cellNumber,
  //     emailAddress: currDependant.emailAddress,
  //     maritalStatus: currDependant.maritalStatus,
  //     employerRefId: currDependant.employerRefId,
  //     paypointRefId: currDependant.paypointRefId,
  //     postalCode: currDependant.postalCode,
  //     group_id: currDependant.group_id,
  //     sex_ID: currDependant.sex_ID,
  //     title_id: currDependant.title_id,
  //     age: currDependant.age,
  //     principalSchemeID: currDependant.principalSchemeID,
  //     physical_Town_ID: currDependant.physical_Town_ID,
  //     physical_Suburb_ID: currDependant.physical_Suburb_ID,
  //     bank_ID: currDependant.bank_ID,
  //     acc_No: currDependant.acc_No,
  //     acc_Name: currDependant.acc_Name,
  //     home_Phone: currDependant.home_Phone,
  //     postal_Phone: currDependant.postal_Phone,
  //     physical_Add1: currDependant.physical_Add1,
  //     accName: currDependant.accName
  //   };

  useEffect(() => {
    // getDependantById();
    // setFormData(initialValue);
    console.log('iye currDependant', currDependant);
  }, []);

  const formik = useFormik({
    initialValues: currDependant,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('dependant 2 yoo', values);
      if (values.dateOfBirth === '') values.dateOfBirth = null;
      if (values.idNumber === '') values.idNumber = null;
      if (values.memberShipNo === '') {
        values.memberShipNo = currentClient.memberShipNo;
      }
      saveClientData(values);
    }
  });
  useEffect(() => {
    const dob = formik.values?.dateOfBirth;
    if (dob) {
      const calculatedAge = moment().diff(moment(dob), 'years');
      if (formik.values.age !== calculatedAge) formik.setFieldValue('age', calculatedAge);
    } else if (formik.values.age !== 0 && formik.values.age !== undefined) {
      formik.setFieldValue('age', 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.dateOfBirth]);

  if (currDependant.dateOfBirth !== undefined)
    currDependant.dateOfBirth = moment(currDependant.dateOfBirth).format('yyyy-MM-DD');
  if (currDependant.membershipStartDate !== undefined)
    currDependant.membershipStartDate = moment(currDependant.membershipStartDate).format(
      'yyyy-MM-DD'
    );
  if (currDependant.termdate)
    currDependant.termdate = moment(currDependant.termdate).format('yyyy-MM-DD');
  const date1 = moment(currDependant.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currDependant.age = diff;

  const handleFormUpdate = (e) => {
    saveClientData(e);
  };

  const saveClientData = (client) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('dependant stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveDependant`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned dependant', result);
          setDependant(result);
          getDependantsList(client.parent_Cif);
          notifyPopup(`Dependant changes saved successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(
            `Error in Saving Dependant Changes, Changes not effected!: ${error}`,
            'error'
          );
        }
      );
  };

  const getDependantById = async (event) => {
    if (id === -1) {
      return;
    }
    if (id === 0) {
      return;
    }
    setLoading(true);

    await axios(`${baseUrl}/api/client/GetDependantByRefId?refId=${id}`).then(
      (result) => {
        setLoading(false);
        console.log('depend result', result);
        setDependant(result.data);
      },
      (error) => {
        notifyPopup(`Error in Getting Dependant!: ${error}`, 'error');
      }
    );
  };

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to search for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        setLoading(false);
        if (result.data.result.length === 0) {
          notifyPopup(`Main member not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('mem result', result);
          console.log('returned parentRef', result.data.result[0].cif_number);
          console.log('returned members cif', result.data.result[0]);
          setCurrentClient(result.data.result[0]);
          // setDependant(result.data.result[0]);
          formik.setFieldValue('parent_Cif', result.data.result[0].cif_number);
          formik.setFieldValue('memberShipNo', result.data.result[0].memberShipNo);
          formik.setFieldValue('surname', result.data.result[0].surname);
          formik.setFieldValue('firstName', '');
          formik.setFieldValue('idNumber', '');
          formik.setFieldValue('cif_number', 0);
          formik.setFieldValue('title_id', '');
          formik.setFieldValue('sex_ID', 0);
          formik.setFieldValue('age', 0);
          formik.setFieldValue('suffix', '');
          formik.setFieldValue('dependents', 0);
          // formik.setFieldValue('maritalStatus', '');
          formik.setFieldValue('memberType_ID', '');
          formik.setFieldValue('dateOfBirth', '');
          formik.setFieldValue('relationship_ID', '');
          formik.setFieldValue('membershipStartDate', moment().format('yyyy-MM-DD'));
          setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          setClientRefId(result.data.result[0].cif_number);
          getDependantsList(result.data.result[0].cif_number);
          setNomDocs([]);
          console.log('curre after z', currDependant);
        }
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const clearCache = async (event) => {
    // clearDependant();
    // formik.setFieldValue('surname', '');
    setLoading(true);
    formik.setFieldValue('firstName', '');
    formik.setFieldValue('idNumber', '');
    formik.setFieldValue('cif_number', 0);
    formik.setFieldValue('title_id', '');
    formik.setFieldValue('sex_ID', 0);
    formik.setFieldValue('age', 0);
    formik.setFieldValue('suffix', '');
    // formik.setFieldValue('maritalStatus', '');
    formik.setFieldValue('memberType_ID', '');
    formik.setFieldValue('dateOfBirth', '');
    formik.setFieldValue('relationship_ID', '');
    formik.setFieldValue('membershipStartDate', moment().format('yyyy-MM-DD'));
    currDependant.suffix = '';
    setNomDocs([]);
    setLoading(false);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    navigate('/dashboard', { replace: true });
  };

  const closePopupDiag = () => {
    setOpenPopupDiag(false);
  };

  const { errors, touched, getFieldProps } = formik;

  return (
    <Container>
      <Card>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={handleLoadingClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <CardContent>
          <FormikProvider value={formik}>
            <Grid container spacing={2} direction="row">
              <Grid item xs={3} sm={3} mr={2}>
                <FormControl>
                  <InputLabel htmlFor="memberCodem">Search Members</InputLabel>
                  <Input
                    id="memberCode"
                    type="text"
                    value={memberCode}
                    onChange={(e) => {
                      setMemberCode(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onMouseDown={handleMouseDownPassword}
                          onClick={() => getMemberInfo()}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
                  <Input id="memberSearchName" type="text" value={memberSearchName} disabled />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} marginRight={6}>
                <Typography component="span" variant="h4">
                  New Dependant
                </Typography>
              </Grid>
            </Grid>
            <Form autoComplete="off" noValidate>
              <Grid container margin={2} direction="row" justifyContent="right" alignItems="right">
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    sx={{ color: '#0c5935' }}
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<CreateIcon />}
                    onClick={() => clearCache()}
                  >
                    Next...
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    type="submit"
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<ThumbUpIcon />}
                    // onClick={() => setOperation('save')}
                  >
                    Save...
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="title_idlabel">Title</InputLabel>
                    <Select
                      id="title_id"
                      value={formik.values.title_id}
                      name="title_id"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        console.log('e here', e.target.value);
                        if (e.target.value === 1) {
                          formik.setFieldValue('sex_ID', 1);
                        } else if (e.target.value === 2 || e.target.value === 3) {
                          formik.setFieldValue('sex_ID', 2);
                        } else {
                          formik.setFieldValue('sex_ID', 0);
                        }
                        formik.setFieldValue('suffix', '');
                        formik.setFieldValue('title_id', e.target.value);
                      }}
                    >
                      {titles.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="firstName" label="First Name" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="surname" label="Last Name" />
                </Grid>
                {/* <Grid item xs={12} sm={2}>
                  <Controls.SelectJson
                    name="memberType_ID"
                    label="Member Type"
                    options={memberTypes}
                  />
                </Grid> */}
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="memberType_IDlabel">Benefit Type</InputLabel>
                    <Select
                      id="memberType_ID"
                      value={formik.values.memberType_ID}
                      name="memberType_ID"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        console.log('e here', e.target.value);
                        if (e.target.value === 1) {
                          formik.setFieldValue('maritalStatus', 2);
                          if (formik.values.sex_ID === 1) {
                            formik.setFieldValue('relationship_ID', 1);
                          } else {
                            formik.setFieldValue('relationship_ID', 2);
                          }
                        } else if (e.target.value === 2) {
                          formik.setFieldValue('maritalStatus', 1);
                          if (formik.values.sex_ID === 1) {
                            formik.setFieldValue('relationship_ID', 4);
                          } else {
                            formik.setFieldValue('relationship_ID', 3);
                          }
                        }
                        formik.setFieldValue('memberType_ID', e.target.value);
                      }}
                    >
                      {memberTypes.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={1}>
                  <Controls.Input name="cif_number" label="Ref Id" disabled />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="suffix" label="Suffix" options={suffixes} />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="idNumber" label="Id Number" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="age" label="Age" disabled />{' '}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
                </Grid>
                {/* <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="maritalStatus"
                    label="Marital Status"
                    options={maritalState}
                  />
                </Grid> */}
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="relationship_ID"
                    label="Relationship to Member"
                    options={relationShips}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="memberStatus"
                    label="Member Status"
                    options={memberStatuses}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.SelectJson
                    name="benefitType"
                    label="Source Type"
                    options={benefitTypes}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.CheckBox name="beneficiary" label="Nominated" />
                </Grid>
              </Grid>
            </Form>
            {/* <DependantsQuick /> */}
            <DependantsDocs2 />
            <Box sx={{ ml: 3, my: 1 }}>
              <Typography variant="h6">Existing Dependants...</Typography>
            </Box>
            <DependantsGlo />
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </FormikProvider>

          <Controls.Popup title="Add Dependant" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <DependantSub closePopup={closePopup} />
          </Controls.Popup>
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </CardContent>
      </Card>
    </Container>
  );
}
